// extracted by mini-css-extract-plugin
module.exports = {"slideInUp":"Toast_slideInUp__5gyQV","panel":"Toast_panel__VNJXa","slideInDown2":"Toast_slideInDown2__yFNWG","fadeOutSlow":"Toast_fadeOutSlow__Qt9EN"};